import { Popover, Select } from "antd-v5";
import classNames from "classnames";
import React from "react";
import { PageChangeCallBack } from "types/pagination";

import ACPagination, {
  ACPaginationProps,
} from "ac-components/ACPagination/ACPagination";

import "./ACPaginationBar.less";

interface Props extends Omit<ACPaginationProps, "onChange"> {
  onChange: PageChangeCallBack;
  className?: string;
  showSizeChanger?: boolean;
  message?: React.ReactNode;
  bordered?: boolean;
  stickyBottom?: boolean;
}

function ACPaginationBar({
  className,
  onChange,
  pageSize = 10,
  page = 1,
  showSizeChanger = true,
  message,
  bordered = true,
  stickyBottom,
  ...restProps
}: Props) {
  const onPageChange = (page: number) => {
    onChange(page, pageSize);
  };

  const onPageSizeChange = (size: number) => {
    onChange(1, size);
  };

  return (
    <div
      className={classNames("ac-pagination-bar", className, {
        bordered,
        "ac-stick-bottom-pagination-bar": stickyBottom,
      })}
    >
      {showSizeChanger ? (
        <Select
          style={{ width: 140 }}
          options={pageSizeOptions}
          placeholder="Page Size"
          value={pageSize}
          onChange={onPageSizeChange}
        />
      ) : (
        <div />
      )}
      <div className="ac-pagination-bar-middle-section text-ellipsis">
        <Popover
          placement="left"
          style={{ backgroundColor: "#000" }}
          content={message}
        >
          {message}
        </Popover>
      </div>
      <ACPagination
        {...restProps}
        onChange={onPageChange}
        pageSize={pageSize}
        page={page}
      />
    </div>
  );
}

export default React.memo(ACPaginationBar);

const pageSizeOptions = [
  {
    label: "Per page: 10",
    value: 10,
  },
  {
    label: "Per page: 20",
    value: 20,
  },
  {
    label: "Per page: 50",
    value: 50,
  },
  {
    label: "Per page: 100",
    value: 100,
  },
];
